import dom from '../lib/dom.js';
import preconditions from '../lib/preconditions.js';

const checkPreconditions = preconditions('setupModalWindow', {
    root: 'element',
    container: 'element',
    content: 'element',
    cancel: 'element',
    confirm: 'element',
    eventHub: 'eventHub',
});

export default function setupModalWindow(params) {
    checkPreconditions(params);

    let _eventName;

    function getFocusableElements(element) {
        const selector = `a, audio[controls], button, details, embed, iframe, img[usemap],
            input:not([type="hidden"]), keygen, label, object[usemap], select,
            textarea, video[controls], [tabindex]`;
        return [...element.querySelectorAll(selector)]
            .filter((ele) => ele.tabIndex > -1) // Only include elements that have a positive tabindex
            .filter((ele) => !ele.matches("[aria-hidden='true'] *"));
    }

    function handleTabbing(shiftKey) {
        const focusableEles = getFocusableElements(params.root);
        const firstFocusableEle = focusableEles[0];
        const lastFocusableEle = focusableEles[focusableEles.length - 1];
        if (document.activeElement === firstFocusableEle && shiftKey) {
            lastFocusableEle.focus();
            return true;
        }
        if (document.activeElement === lastFocusableEle && !shiftKey) {
            firstFocusableEle.focus();
            return true;
        }
    }

    function handleKeyboard(event) {
        let isHandled = false;

        if (event.keyCode === 27 /* Escape */) {
            isHandled = true;
            hide();
        } else if (event.keyCode === 9 /* Tab */) {
            isHandled = handleTabbing(event.shiftKey);
        } else if (event.keyCode === 13 /* Enter */) {
            isHandled = true;
            confirm(_eventName);
        }

        if (isHandled) {
            event.stopPropagation();
            event.preventDefault();
        }

        return isHandled;
    }

    function focusElement() {
        const autofocusEle =
            params.root.querySelector('[autofocus]') ||
            params.root.querySelector('[data-autofocus]') ||
            getFocusableElements(params.root)[0] ||
            params.root;
        autofocusEle.focus();
    }

    function show(data) {
        _eventName = data.eventName;

        params.confirm.textContent = data.buttonText;
        if (data.hideConfirm) {
            dom.addClass('u-display-none', params.confirm);
        } else {
            dom.removeClass('u-display-none', params.confirm);
        }

        const style = params.root.querySelector('.modal__container').style;
        style.removeProperty('max-height');
        style.removeProperty('max-width');
        style.top = '0';
        style.right = '0';
        style.bottom = '0';
        style.left = '0';

        params.root.querySelector('#modalPrimaryTitle').textContent = data.title;
        params.container.setAttribute('aria-label', data.title);

        dom.on(params.confirm, 'click', (event) => {
            event.stop();
            confirm(data.eventName);
        });
        window.addEventListener('popstate', handleNavigation);
        window.addEventListener('keydown', handleKeyboard);
        window.history.pushState({ modal: true }, null, null);

        dom.addClass('modal--is-active', params.root);
        dom.addClass('modal--document-body', document.body);
        focusElement();
    }

    function hide() {
        _eventName = null;
        window.removeEventListener('popstate', handleNavigation);
        window.removeEventListener('keydown', handleKeyboard);

        dom.off(params.confirm);

        dom.removeClass('modal--is-active', params.root);
        dom.removeClass('modal--document-body', document.body);
    }

    function confirm(eventName) {
        params.eventHub.publish(eventName);
    }

    function handleNavigation() {
        hide();
    }

    dom.removeClass('modal--document-body', document.body);

    // TODO REIS-2872 this shit triggers when it shouldn't...
    // dom.on(document, 'click', (event) => {
    //     if (!params.container.contains(event.target) && !params.content.contains(event.target)) {
    //         hide();
    //     }
    // });

    dom.on(params.cancel, 'click', (event) => {
        event.stop();
        window.history.back();
    });

    params.eventHub.subscribe('show-modal', show);
    params.eventHub.subscribe('hide-modal', hide);
}
